var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"consent-message"},[_c('span',[_vm._v(" By continuing, you agree to our "),_c('a',{attrs:{"href":"#","target":"_blank"}},[_vm._v("terms of use")]),_vm._v(" and "),_c('a',{attrs:{"href":"#","target":"_blank"}},[_vm._v("privacy policy")])])])
}]

export { render, staticRenderFns }